import { getUa, isSayWeeeApp } from './weeeapp';
import callAppFunction from './bridge';
/**
 * 是否是ios 不是ios就是安卓
 * @param ctx
 */
export const isIOS = function (ctx?) {
  const ua = getUa(ctx);
  if (ua) {
    return !!ua?.match(/(iPad|iPhone|iPod)/i);
  } else {
    return false;
  }
};

/**
 * weee app的安卓手机
 */
export function isWeeeAndroid(ctx?) {
  const result = isSayWeeeApp(ctx) && !isIOS(ctx);
  return result;
}

export const getAppVersionNum = (ctx?) => {
  const ua = getUa(ctx);
  const version = ua?.match(/(?:weeeapp|masgustoapp)\s([\d.]+)/i)?.[1];
  const [majorVersion = 0, minorVersion = 0, minVersion = 0] = (version || '').trim().split('.');
  return {
    majorVersion: +majorVersion,
    minorVersion: +minorVersion,
    minVersion: +minVersion
  };
};

// iOS 14.7 Android 14.0及其以上版本支持 purchaseStatusNotify jscall
export function isAppSupportPurchaseStatusNotify(ctx?) {
  const isWeeeIosApp = isSayWeeeApp(ctx) && isIOS(ctx);
  const isWeeeAndroidApp = isWeeeAndroid(ctx);
  const { majorVersion, minorVersion, minVersion } = getAppVersionNum(ctx);
  const iosVersionValid = isWeeeIosApp && ((majorVersion === 14 && minorVersion >= 7) || majorVersion >= 15);
  const androidVersionValid = isWeeeAndroidApp && ((majorVersion === 14 && minorVersion >= 0) || majorVersion >= 15);
  const versionValid = iosVersionValid || androidVersionValid;
  return !!versionValid;
}

/**
 * 同步app收藏列表
 */
export const appCollectStatusNotify = (ids: any[] = [], status: 'add' | 'remove' | 'reset', type = 'product') => {
  try {
    if (isSayWeeeApp()) {
      const isAppSupportCollectStatusNotifyVersion = isAppSupportCollectStatusNotify();
      if (isAppSupportCollectStatusNotifyVersion) {
        const args = {
          type: type,
          status: status,
          ids: ids.map(i => Number(i))
        };
        callAppFunction('collectStatusNotify', args);
      }
    }
  } catch (error) {
    console.log('collectStatusNotify error', error);
  }
};

//Android 14.1 iOS 14.8及其以上版本支持 collectStatusNotify 和onPopupWindowDidFinish jscall
export function isAppSupportCollectStatusNotifyAndOnPopupWindowDidFinish(ctx?) {
  const isWeeeIosApp = isSayWeeeApp(ctx) && isIOS(ctx);
  const isWeeeAndroidApp = isWeeeAndroid(ctx);
  const { majorVersion, minorVersion, minVersion } = getAppVersionNum(ctx);
  const iosVersionValid = isWeeeIosApp && ((majorVersion === 14 && minorVersion >= 8) || majorVersion >= 15);
  const androidVersionValid = isWeeeAndroidApp && ((majorVersion === 14 && minorVersion >= 1) || majorVersion >= 15);
  const versionValid = iosVersionValid || androidVersionValid;
  return !!versionValid;
}

export function isAppSupportCollectStatusNotify(ctx?) {
  return isAppSupportCollectStatusNotifyAndOnPopupWindowDidFinish(ctx);
}
export function isAppSupportOnPopupWindowDidFinish(ctx?) {
  return isAppSupportCollectStatusNotifyAndOnPopupWindowDidFinish(ctx);
}
